// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type DistinguishedFolderId from "../contract/DistinguishedFolderId";

export default function distinguishedFolderId(data: DistinguishedFolderId): DistinguishedFolderId {
    const result: DistinguishedFolderId = {
        __type: "DistinguishedFolderId:#Exchange",
        ...data,
    };
    
    return result;
}
